/* eslint-disable no-shadow */
import swal from "sweetalert2";
import iziToast from "izitoast";
const { title } = require("../../package.json");

export default function install(Vue) {
  const functions = {
    question(text, type, details) {
      const options = {
        title,
        html: formatMessage(text, details),
        type,
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        allowEscapeKey: false,
      };
      return swal(options);
    },
    alert(text, type, details) {
      const options = {
        title,
        // html: true,
        html: formatMessage(text, details),
        type,
      };
      return swal(options);
    },
    toast(message, timeout, type, details) {
      const options = {
        title,
        message: formatMessage(message, details),
        timeout,
        position: "topRight",
        layout: 2,
      };
      return iziToast[type](options);
    },
  };

  const formatMessage = (message, details) =>
    details
      ? `<h4>${message}</h4>Detalhes:</br>${details}`
      : `<h4>${message}</h4>`;

  Object.defineProperties(Vue.prototype, {
    $messages: {
      get() {
        return {
          warning(details) {
            const type = "warning";
            return {
              question: (text) => functions.question(text, type, details),
              alert: (text) => functions.alert(text, type, details),
              toast: (text) => functions.toast(text, 6000, type, details),
            };
          },
          info(details) {
            const type = "info";
            return {
              question: (text) => functions.question(text, type, details),
              alert: (text) => functions.alert(text, type, details),
              toast: (text) => functions.toast(text, 4000, type, details),
            };
          },
          success(details) {
            const type = "success";
            return {
              question: (text) => functions.question(text, type, details),
              alert: (text) => functions.alert(text, type, details),
              toast: (text) => functions.toast(text, 1000, type, details),
            };
          },
          error(details) {
            const type = "error";
            return {
              question: (text) => functions.question(text, type, details),
              alert: (text) => functions.alert(text, type, details),
              toast: (text) => functions.toast(text, 6000, type, details),
            };
          },
        };
      },
    },
  });
}
